// Helper to safely pull the "description" HTML out of a CMS API response.
// Different CMS endpoints can return the payload in slightly different
// shapes (keyed object, array, or a flat object), so this normalizes all
// of them instead of assuming one fixed structure.
export const extractCmsDescription = (data, key) => {
  if (!data) return "";

  const source = key && data[key] !== undefined ? data[key] : data;

  if (Array.isArray(source)) {
    return source[0]?.description || "";
  }

  if (typeof source === "object") {
    return source?.description || "";
  }

  return "";
};

export default extractCmsDescription;
